import React, { useMemo } from 'react';

import { isCompletedClass, isOngoingClass } from 'features/classCreation';
import styles from './SbatGroupNudgeMessage.module.scss';

export default function SbatGroupNudgeMessage({
  sbatGroup,
  ongoingMessage = `This class is currently ongoing.
        You can only make only limited changes.
        Proceed only if you are sure of what you are doing`,
  completedMessage = `This class is already completed.
        Making any further changes to it is very limited.
        Proceed only if you are sure of what you are doing.`,
}) {
  const nudgeMessage = useMemo(() => {
    if (isOngoingClass(sbatGroup.date_of_topic)) {
      return ongoingMessage;
    } else if (isCompletedClass(sbatGroup.date_of_topic)) {
      return completedMessage;
    } else {
      return null;
    }
  }, [completedMessage, ongoingMessage, sbatGroup.date_of_topic]);

  return (
    nudgeMessage && <div className={styles.nudgeMessage}>{nudgeMessage}</div>
  );
}
